<template>
  <div ref="rootRef" class="collage-carousel">
    <!-- FONDO ROSA -->
    <div ref="bgRef" class="bg-rosa"></div>

    <!-- 🌸 FLORES Y RAMAS EN ORILLAS (AL FRENTE) -->
    <!-- Superior Izquierda -->
    <div class="deco-wrapper deco-lt">
      <img src="@/assets/rama.png" class="rama-img" alt="Rama" />
      <img src="@/assets/monio.png" class="flor-img" alt="Moño" />
    </div>

    <!-- Inferior Derecha -->
    <div class="deco-wrapper deco-rb">
      <img src="@/assets/rama.png" class="rama-img" alt="Rama" />
      <img src="@/assets/monio.png" class="flor-img" alt="Moño" />
    </div>

    <!-- IMÁGENES -->
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        ref="collageItems"
        class="collage-item"
        @click="enlargeImage(index)"
      >
        <img
          :src="image"
          class="collage-image"
          :alt="'Imagen ' + index"
        />
      </div>
    </div>

    <!-- MODAL -->
    <div
      v-if="isImageEnlarged"
      class="image-modal"
      @click="closeModal"
    >
      <img
        :src="images[currentIndex]"
        class="enlarged-image"
        alt="Imagen ampliada"
      />
    </div>

    <div class="rasgado rasgado-inferior"></div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimadoMagico',
  setup() {
    const images = [
      require('@/assets/30994_11zon.webp')
    ]

    const rootRef = ref(null)
    const bgRef = ref(null)
    const collageItems = ref([])

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    onMounted(async () => {
      await nextTick()

      const flores = rootRef.value.querySelectorAll('.flor-img')
      const ramas = rootRef.value.querySelectorAll('.rama-img')
      const wrappers = rootRef.value.querySelectorAll('.deco-wrapper')

      // Estados iniciales ultra limpios para entrada rápida
      gsap.set(bgRef.value, { opacity: 0 })
      gsap.set(flores, { opacity: 0, scale: 0.85, y: 10, filter: 'blur(6px)' })
      gsap.set(ramas, { opacity: 0, scale: 0.8, filter: 'blur(6px)' })
      gsap.set(collageItems.value, { opacity: 0, y: 25, scale: 0.98 })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          // Timeline ágil estilo editorial
          const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

          // 1. Fondo + Imagen aparecen casi en simultáneo
          tl.to(bgRef.value, { opacity: 1, duration: 0.4 })
            .to(collageItems.value, {
              opacity: 1,
              y: 0,
              scale: 1,
              duration: 0.6,
              stagger: 0.1
            }, '-=0.3')

          // 2. Elementos decorativos (Moño + Ramas) aparecen velozmente al frente
          .to(flores, {
            opacity: 1,
            scale: 1,
            y: 0,
            filter: 'blur(0px)',
            duration: 0.5,
            stagger: 0.1
          }, '-=0.4')

          .to(ramas, {
            opacity: 0.95,
            scale: 1,
            filter: 'blur(0px)',
            duration: 0.5,
            stagger: 0.1
          }, '-=0.4')

          // Flotación continua sutil
          wrappers.forEach((wrapper, i) => {
            gsap.to(wrapper, {
              y: `+=${gsap.utils.random(4, 8)}`,
              rotate: gsap.utils.random(-2, 2),
              duration: gsap.utils.random(3, 4),
              repeat: -1,
              yoyo: true,
              ease: 'sine.inOut',
              delay: i * 0.3
            })
          })

          io.disconnect()
        })
      }, { threshold: 0.15 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return {
      images, rootRef, bgRef, collageItems, currentIndex,
      isImageEnlarged, enlargeImage, closeModal
    }
  }
}
</script>

<style scoped>
.collage-carousel {
  position: relative;
  width: 100%;
  min-height: 70vh;
  margin-bottom: -40px;
  overflow: visible; /* Permite que las decoraciones no se corten */
}

.bg-rosa {
  position: absolute;
  inset: 0;
  background: #f0c9d3;
  z-index: 0;
}

/* 🌸 DECORACIONES - Z-INDEX AL FRENTE (10) */
.deco-wrapper {
  position: absolute;
  z-index: 10; /* Se colocan por encima de las imágenes */
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.flor-img {
  width: 120px;
  max-width: 35vw;
  position: relative;
  z-index: 12;
  height: auto;
  object-fit: contain;
}

.rama-img {
  position: absolute;
  width: 250px !important;
  max-width: 80vw;
  height: auto;
  object-fit: contain;
  z-index: 11;
  margin-top:120px;
  filter: brightness(1.05);
}

/* Posicionamiento calibrado para evitar recortes por bordes */
.deco-lt { 
  top: 2vh; 
  left: -10px; 
}

.deco-rb { 
  bottom: 6vh; 
  right: -10px; 
}

.deco-rb .rama-img {
  margin-top: 0px; /* Ajuste para centrar la rama inferior */
  transform: rotate(180deg); /* Invierte la orientación para variedad */
}

/* GRID */
.collage-grid {
  position: relative;
  z-index: 2; /* Por debajo de las decoraciones */
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  padding: 8vh 0;
}

.collage-item {
  grid-column: span 12;
  opacity: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin-bottom: 5vh;
  will-change: transform, opacity;
}

.collage-image {
  width: 85%;
  max-width: 500px;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.12);
  transition: transform 0.4s ease;
}

.collage-image:hover {
  transform: scale(1.02);
}

/* MODAL */
.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 10, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.enlarged-image {
  max-width: 90%;
  max-height: 85%;
  border-radius: 12px;
  box-shadow: 0 0 30px rgba(0,0,0,0.5);
}

.rasgado-inferior {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #f0c9d3;
  clip-path: polygon(0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%, 100% 0%, 0% 0%);
  z-index: 1; /* Detrás de las decoraciones */
}
</style>